/**
 * Source unique pour la clé d'API Google Maps côté frontend.
 *
 * V14.62 Sprint 17 — séparation des clés Google Cloud :
 *   • `REACT_APP_GOOGLE_MAPS_API_KEY` (NOUVEAU, recommandé)
 *       → Clé strictement dédiée à la cartographie
 *         (Maps JavaScript API, Map Tiles, Places, Geocoding…).
 *         À restreindre à `Maps APIs` + HTTP referrers dans Google Cloud.
 *
 *   • `REACT_APP_GOOGLE_MAPS_KEY` (LEGACY, conservé en fallback)
 *       → Ancien nom historique. Utilisé pendant la transition pour ne
 *         pas casser les déploiements existants. À retirer du `.env`
 *         dès que la nouvelle clé est en production sur tous les
 *         environnements.
 *
 * Aucune clé n'est jamais codée en dur — seules les variables CRA
 * (préfixe obligatoire `REACT_APP_`) sont consultées au build.
 */

export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  || process.env.REACT_APP_GOOGLE_MAPS_KEY
  || '';

export const HAS_GOOGLE_MAPS_API_KEY = !!GOOGLE_MAPS_API_KEY;

/**
 * Nom canonique de la variable d'env à documenter dans la console et
 * dans les messages d'erreur UI quand la clé manque.
 */
export const GOOGLE_MAPS_API_KEY_ENV_NAME = 'REACT_APP_GOOGLE_MAPS_API_KEY';

export default GOOGLE_MAPS_API_KEY;
